import ApiClient from "@common/api/ApiClient";

class ComplianceCMSClient extends ApiClient {
  constructor() {
    super("Compliance");
  }

  SetUpReturn = async (payload) => {
    return await this.post("Compliance/SetUpReturn", payload);
  };

  CompleteReturn = async (payload) => {
    return await this.post("Compliance/CompleteReturn", payload);
  };

  DownloadReturn = async (processedId) => {
    return await this.get(`Compliance/DownloadReturn/${processedId}`, {
      responseType: "arraybuffer",
    });
  };
}

const client = new ComplianceCMSClient();

export default client;
